/* nebe / dlaždice produktu v barvě (v4): JEDNA pravda pro celý web
   Custom element <nebe-dlazdice class="nebe-dl nebe-kt-card" data-kt-list="…" [data-kt-mode="carousel"]>.
   Kolekce, homepage karusel, doporučení a nedávno prohlížené (vkládané přes innerHTML),
   vyhledávání, košík. Element se inicializuje sám (connectedCallback), i po innerHTML.

   - fotky: bar pozice, líné dotažení 2. a 3. fotky, swipe (dotyk), tažení myší (desktop),
     klik po tažení se zruší, klik na fotku bez tažení otevře detail
   - analytika nebe:select_item {list, model, base, index, url}
   - zarovnání řad: swatche, štítek, název a barva sourozeneckých dlaždic na stejné výšce,
     v jakémkoli kontejneru (mřížka výpisu, grid motivu, karusel); window.NebeDlazdice.schedule()
   Karusel (data-kt-mode="carousel"): jen 1. fotka, bez baru a tažení, klik řeší odkaz. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('nebe-dlazdice')) return;

  var PARTS = ['.nebe-kt-colors', '.nebe-kt-card__label', '.nebe-kt-card__name', '.nebe-kt-card__color'];

  function mq(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }
  function reducedMotion() {
    return mq('(prefers-reduced-motion: reduce)');
  }
  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytika nesmí rozbít dlaždici */ }
  }

  function markReady(e) { e.currentTarget.classList.add('is-kt-ready'); }
  function loadImgs(card, limit) {
    var imgs = card.querySelectorAll('.nebe-kt-card__img');
    var first = imgs[0];
    for (var i = 1; i < imgs.length && i < limit; i++) {
      var img = imgs[i];
      if (!img.hasAttribute('data-src') && !img.hasAttribute('data-srcset')) continue;
      img.addEventListener('load', markReady, { once: true });
      // sizes před srcset, jinak prohlížeč vybere podle výchozích 100vw
      if (img.getAttribute('data-sizes')) img.sizes = img.getAttribute('data-sizes');
      else if (!img.sizes && first && first.sizes) img.sizes = first.sizes;
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      if (img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-sizes');
      if (img.complete && img.naturalWidth) img.classList.add('is-kt-ready');
    }
  }
  function loadAll(card) {
    if (card._ktAll) return;
    card._ktAll = true;
    loadImgs(card, 99);
  }

  /* ---------- líné fotky na dotyku: 2. fotka, až je dlaždice vidět ---------- */

  var io = null;
  function lazyIO() {
    if (io || !('IntersectionObserver' in window) || !mq('(hover: none)')) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        loadImgs(entry.target, 2);
      });
    }, { rootMargin: '0px 0px 200px 0px' });
    return io;
  }

  /* ---------- tažení myší (jedno sdílené, na dokumentu jen během tažení) ---------- */

  var drag = null;
  var noClick = false;

  function onMove(e) {
    var d = drag;
    if (!d) return;
    var dx = e.clientX - d.x;
    if (!d.moved) {
      if (Math.abs(dx) < 10) return;             // práh, ať obyčejný klik zůstane klikem
      d.moved = true;
      d.track.classList.add('is-kt-drag');
    }
    e.preventDefault();
    d.track.scrollLeft = d.left - dx;
  }
  function onUp() {
    var d = drag;
    drag = null;
    document.removeEventListener('pointermove', onMove);
    document.removeEventListener('pointerup', onUp);
    document.removeEventListener('pointercancel', onUp);
    if (!d || !d.moved) return;
    var t = d.track;
    var w = t.clientWidth || 1;
    var from = Math.round(d.left / w);
    var to = Math.round(t.scrollLeft / w);
    // krátké švihnutí (> 40 px) posune aspoň o jednu fotku
    var delta = t.scrollLeft - d.left;
    if (to === from && Math.abs(delta) > 40) to = from + (delta > 0 ? 1 : -1);
    var max = Math.round((t.scrollWidth - w) / w);
    to = Math.max(0, Math.min(max, to));
    t.classList.remove('is-kt-drag');
    t.scrollTo({ left: to * w, behavior: reducedMotion() ? 'auto' : 'smooth' });
    // klik, který po tažení prohlížeč pošle, nesmí otevřít detail
    noClick = true;
    setTimeout(function () { noClick = false; }, 0);
  }

  /* ---------- zarovnání řad v libovolném kontejneru ---------- */

  var pending = [];
  var alignRaf = 0;
  var watched = typeof WeakMap === 'function' ? new WeakMap() : null;
  var ro = null;

  // kontejner = nejbližší předek s víc dlaždicemi (mřížka, seznam, track karuselu)
  function containerOf(card) {
    var el = card.parentElement;
    for (var i = 0; el && i < 6; i++, el = el.parentElement) {
      if (el.querySelectorAll('nebe-dlazdice').length > 1) return el;
    }
    return null;
  }

  function schedule(container) {
    if (!container) return;
    if (pending.indexOf(container) === -1) pending.push(container);
    if (alignRaf) return;
    alignRaf = window.requestAnimationFrame(function () {
      alignRaf = 0;
      var list = pending;
      pending = [];
      list.forEach(function (c) { if (c.isConnected) alignNow(c); });
    });
  }

  // šířka kontejneru (okno, rotace, drawer motivu) → zarovnat znovu; výška ne (mění ji zarovnání samo)
  function watch(container) {
    if (!container || !window.ResizeObserver || !watched || watched.has(container)) return;
    watched.set(container, { w: -1 });
    if (!ro) {
      ro = new ResizeObserver(function (entries) {
        entries.forEach(function (en) {
          var st = watched.get(en.target);
          var w = Math.round(en.contentRect.width);
          if (!st || w === st.w) return;
          var first = st.w === -1;
          st.w = w;
          if (!first) schedule(en.target);
        });
      });
    }
    ro.observe(container);
  }

  // Nejdřív zrušit dřívější hodnoty (zápis), pak změřit vše (čtení), nakonec nastavit (zápis):
  // jeden přepočet layoutu na kontejner. Chybí-li u dlaždice část (štítek bez textu), její výška
  // se přenese jako horní padding na další přítomnou část, ať zbytek řádku nesjede nahoru.
  function alignNow(container) {
    var cards = Array.prototype.filter.call(container.querySelectorAll('nebe-dlazdice'), function (c) {
      return c.getClientRects().length > 0;
    });
    var cells = cards.map(function (card) {
      return PARTS.map(function (sel) {
        var el = card.querySelector(sel);
        if (el && (el.style.minHeight || el.style.paddingTop)) {
          el.style.minHeight = '';
          el.style.paddingTop = '';
        }
        return el;
      });
    });
    var heights = cells.map(function (row) {
      return row.map(function (el) { return el ? el.offsetHeight : 0; });
    });
    var rows = {};
    var order = [];
    cards.forEach(function (card, t) {
      var top = Math.round(card.getBoundingClientRect().top);
      if (!rows[top]) { rows[top] = []; order.push(top); }
      rows[top].push(t);
    });
    var writes = [];
    order.forEach(function (top) {
      var idx = rows[top];
      if (idx.length < 2) return;
      var carry = {};
      PARTS.forEach(function (sel, p) {
        var max = 0;
        idx.forEach(function (t) { if (heights[t][p] > max) max = heights[t][p]; });
        idx.forEach(function (t) {
          var el = cells[t][p];
          var pad = carry[t] || 0;
          if (!el) { carry[t] = pad + max; return; }
          carry[t] = 0;
          if (pad || heights[t][p] < max) writes.push([el, max + pad, pad]);
        });
      });
    });
    writes.forEach(function (w) {
      w[0].style.minHeight = w[1] + 'px';
      if (w[2]) w[0].style.paddingTop = w[2] + 'px';
    });
  }

  // Jost se dotahuje později a mění výšku zalomených řádků
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      Array.prototype.forEach.call(document.querySelectorAll('nebe-dlazdice'), function (card) { schedule(containerOf(card)); });
    });
  }

  /* ---------- element ---------- */

  class NebeDlazdice extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);
      this._onPointerOver = this._onPointerOver.bind(this);
      this._onPointerDown = this._onPointerDown.bind(this);
      this._onDragStart = this._onDragStart.bind(this);
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      if (this._on) return;
      this._on = true;
      try { this._init(); } catch (e) { if (window.console) console.error('nebe-dlazdice', e); }
    }

    disconnectedCallback() {
      this._on = false;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('click', this._onClickCapture, true);
      this.removeEventListener('pointerover', this._onPointerOver);
      this.removeEventListener('pointerdown', this._onPointerDown);
      this.removeEventListener('dragstart', this._onDragStart);
      this.removeEventListener('scroll', this._onScroll, true);
      if (io) io.unobserve(this);
    }

    get carousel() {
      return this.getAttribute('data-kt-mode') === 'carousel';
    }

    _init() {
      this.addEventListener('click', this._onClick);
      this.addEventListener('click', this._onClickCapture, true);
      if (!this.carousel) {
        var imgs = this.querySelectorAll('.nebe-kt-card__img');
        var bar = this.querySelector('.nebe-kt-card__bar');
        if (bar) bar.style.setProperty('--kt-n', imgs.length || 1);
        for (var i = 0; i < imgs.length; i++) imgs[i].draggable = false;
        this.addEventListener('pointerover', this._onPointerOver);
        this.addEventListener('pointerdown', this._onPointerDown);
        this.addEventListener('dragstart', this._onDragStart);
        this.addEventListener('scroll', this._onScroll, true);
        var obs = lazyIO();
        if (obs && this.querySelector('.nebe-kt-card__img[data-src], .nebe-kt-card__img[data-srcset]')) obs.observe(this);
      }
      var c = containerOf(this);
      watch(c);
      schedule(c);
    }

    // pořadí pro analytiku: data-kt-index (výpis), jinak pořadí mezi dlaždicemi v sekci
    _index() {
      var host = this.closest('[data-kt-index]');
      if (host) return parseInt(host.getAttribute('data-kt-index'), 10);
      var root = this.closest('.shopify-section') || document;
      return Array.prototype.indexOf.call(root.querySelectorAll('nebe-dlazdice'), this);
    }

    _select(url) {
      publish('nebe:select_item', {
        list: this.getAttribute('data-kt-list') || '',
        model: this.getAttribute('data-kt-model') || '',
        base: this.getAttribute('data-kt-base') || '',
        index: this._index(),
        url: url
      });
    }

    _onClickCapture(e) {
      if (!noClick) return;
      noClick = false;
      e.preventDefault();
      e.stopPropagation();
    }

    _onClick(e) {
      if (e.defaultPrevented || !(e.target instanceof Element)) return;
      var link = e.target.closest('a');
      if (link && this.contains(link)) { this._select(link.href); return; }
      // track je nad odkazem karty: klik na fotku bez tažení otevře detail
      if (this.carousel || !e.target.closest('.nebe-kt-card__media') || e.button > 0) return;
      var main = this.querySelector('.nebe-kt-card__link');
      if (!main) return;
      this._select(main.href);
      if (e.metaKey || e.ctrlKey) window.open(main.href, '_blank', 'noopener');
      else window.location.href = main.href;
    }

    // desktop: další fotky dotáhnout už při najetí na fotku, ukážou se ale jen tažením
    _onPointerOver(e) {
      if (e.pointerType !== 'mouse' || !(e.target instanceof Element) || !e.target.closest('.nebe-kt-card__media')) return;
      loadAll(this);
    }

    _onPointerDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !(e.target instanceof Element)) return;
      var track = e.target.closest('.nebe-kt-card__track');
      if (!track || track.scrollWidth <= track.clientWidth + 1) return;
      loadAll(this);
      drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    }

    _onDragStart(e) {
      if (e.target instanceof Element && e.target.closest('.nebe-kt-card__media')) e.preventDefault();
    }

    // swipe / tažení / kolečko: dotáhnout zbytek fotek a posunout ukazatel
    _onScroll(e) {
      var track = e.target;
      if (!(track instanceof Element) || !track.classList.contains('nebe-kt-card__track')) return;
      loadAll(this);
      if (track._ktRaf) return;
      var bar = this.querySelector('.nebe-kt-card__bar');
      track._ktRaf = window.requestAnimationFrame(function () {
        track._ktRaf = 0;
        var max = track.scrollWidth - track.clientWidth;
        if (bar) bar.style.setProperty('--kt-p', max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)).toFixed(3) : '0');
      });
    }
  }

  window.NebeDlazdice = {
    // zarovnat řady v kontejneru (výpis po změně viditelnosti, cizí grid po vložení)
    schedule: schedule,
    align: alignNow,
    loadImgs: loadImgs
  };
  window.customElements.define('nebe-dlazdice', NebeDlazdice);
})();
